import { ca } from '@cian/analytics';

import { EChatbotPayload } from '../../services/сhatbot/fetchChatbotActionButtons';

export const trackSendChatbotMessage = (text: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: EChatbotPayload.SendMessage,
    page: {
      extra: {
        chat_id: 'chatbot',
        text,
      },
    },
  });
};
